import * as React from "react";
import { useParams } from "react-router-dom";
import { PaginationProvider, SelectedRowsProvider, ModalProvider } from "common/contexts";
import SecurityUI from "./SecurityUI";
import EventProceduresModals from "./EventProceduresModals";
function Index({ navigationComponent = null }) {
  const { viewType } = useParams();
  return /* @__PURE__ */ React.createElement(PaginationProvider, null, /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(ModalProvider, null, navigationComponent, /* @__PURE__ */ React.createElement(SecurityUI, { viewType }), /* @__PURE__ */ React.createElement(EventProceduresModals, null))));
}
export default Index;
